/* Lightweight, fire-and-forget filter analytics.
 *
 * Sends a debounced ping to /api/analytics/search-filter when the user applies
 * non-trivial filters on the Properties page, plus discrete events on save /
 * load of a saved search. No PII; only facet values are sent.
 */
import { API } from "./api";

let pendingTimer = null;
let lastApplyKey = "";

function payload(filters, event = "apply") {
  return {
    event,
    zone: filters.zone || null,
    property_type: filters.property_type || null,
    rent_sale: filters.rent_sale || null,
    emirate: filters.emirate || null,
    has_size_filter: Boolean(filters.min_size || filters.max_size),
    has_price_filter: Boolean(filters.min_price || filters.max_price),
    has_search: Boolean(filters.search),
  };
}

function fire(body) {
  try {
    fetch(`${API}/analytics/search-filter`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      // explicitly non-credentialed, no cookies; fire-and-forget
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* analytics is non-critical */
  }
}

/** Debounced apply tracking — only fires once filters settle for 800ms. */
export function trackFilterApply(filters) {
  const body = payload(filters, "apply");
  const key = JSON.stringify(body);
  if (key === lastApplyKey) return; // no change, skip
  lastApplyKey = key;
  if (pendingTimer) clearTimeout(pendingTimer);
  pendingTimer = setTimeout(() => {
    pendingTimer = null;
    fire(body);
  }, 800);
}

export function trackFilterSave(filters) {
  fire(payload(filters, "save"));
}

export function trackFilterLoad(filters) {
  fire(payload(filters, "load"));
}
